export default [
  { to: 'open', title: 'Öppenvård' },
  { to: 'sluten', title: 'Slutenvård' },
  { to: 'tand', title: 'Tandvård' },
  { to: 'k_profilax', title: 'Kirurgisk profylax' },
  { to: 'information', title: 'Information' },
];
